import { useThree } from '@react-three/fiber'
import { useEffect } from 'react'
import * as THREE from 'three'

import { useShelfRegistry } from '@components/storeMap/floor/ShelfRegistry'
import { isTestMode } from '@utils/env.ts'

interface TestBridge {
  toScreenPosition: (name: string) => { x: number; y: number } | null
  getRegistry: () => string[]
}

declare global {
  interface Window {
    __R3F_TEST__?: TestBridge
  }
}

function TestBridge() {
  if (!isTestMode) return null

  // we don't care about the rules of hooks here since this
  // code will never show up in product / dev builds

  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { camera, gl } = useThree()

  // eslint-disable-next-line react-hooks/rules-of-hooks
  const registry = useShelfRegistry<THREE.Object3D>()

  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    window.__R3F_TEST__ = {
      toScreenPosition: (name: string) => {
        const object = registry.get(name)
        if (!object) return null

        const vector = new THREE.Vector3()
        object.getWorldPosition(vector)

        vector.project(camera)

        const rect = gl.domElement.getBoundingClientRect()
        const x = Math.round((0.5 + vector.x / 2) * rect.width + rect.left)
        const y = Math.round((0.5 - vector.y / 2) * rect.height + rect.top)

        return { x, y }
      },
      getRegistry: () => Array.from(registry.keys()),
    }

    // Cleanup on unmount
    return () => {
      delete window.__R3F_TEST__
    }
  }, [registry, camera, gl])

  return null
}

export default TestBridge